
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/topBar/templateEditBanner/TemplateEditBanner.scss.css.virtualfile';
        module.exports = {"templateEditBanner":"_templateEditBanner_1ousx_1","templateEditBannerText":"_templateEditBannerText_1ousx_9"};